const CRN = ({ ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 2048 2048"
    width="512"
    height="512"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(969)"
      d="m0 0h112l58 6 46 6 35 6 41 9 32 8 31 9 43 14 42 16 37 16 38 18 25 13 24 14 23 13 23 15 16 10 14 10 18 13 14 10 16 13 13 10 26 22 10 9 8 7 16 15 11 11 8 7 12 13 13 13 7 8 11 12 9 11 10 11 20 25 10 13 14 19 13 19 8 11 13 20 16 26 16 28 11 20 8 16 13 27 16 36 12 30 13 36 10 31 10 35 10 41 8 40 7 45 5 44 4 43v96l-5 58-6 48-4 26-7 37-10 42-10 36-13 41-9 25-11 28-15 35-17 36-16 31-28 48-15 23-9 14-12 17-10 14-12 16-14 18-13 16-12 14-13 15-12 13-15 16-31 31-8 7-9 9-11 9-12 11-11 9-13 11-12 9-15 12-17 12-14 10-27 18-19 12-15 9-21 12-25 14-17 9-23 11-24 11-36 15-41 15-33 11-43 12-42 10-35 7-46 7-52 6-34 3h-100l-52-5-49-6-37-6-48-10-35-9-44-13-35-12-26-10-29-12-35-16-29-14-28-15-24-14-20-12-22-14-20-14-17-12-19-14-10-8-14-11-11-9-14-12-15-13-13-12-8-8-8-7-30-30-7-8-11-11-9-11-10-11-7-8-13-16-13-17-11-14-12-17-13-18-11-17-14-22-9-15-15-26-14-26-17-34-13-29-15-37-14-38-14-44-11-42-9-39-8-45-6-45-6-61v-112l5-50 4-34 7-44 10-48 9-36 11-38 14-41 12-32 18-42 10-22 8-16 13-25 13-23 16-27 9-14 11-17 8-12 13-18 12-17 11-14 12-15 7-9 13-15 9-11 12-13 7-8 7-7 7-8 31-31 8-7 14-13 11-9 11-10 11-9 14-11 15-12 16-12 17-12 20-14 16-10 20-13 29-17 24-13 29-15 32-15 33-14 34-13 47-16 42-12 33-8 39-8 49-8 32-4 41-4z"
      fill="#FEA72B"
    />
    <path
      transform="translate(780,970)"
      d="m0 0 9 2 33 11 22 10 20 11 18 12 13 10 11 9 10 9 20 20 11 14 10 13 9 14 12 21 12 27 9 27 6 26 4 28 1 17 1 193v76l-3 1-21-12-27-18-18-14-15-13-7-6v-2l-4-2-9-9-7-8-9-10-8-10-14-19-11-17-12-21-9-17-9-21-9-25-7-23-5-23-4-25-6-59-13-137-4-49z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1263,970)"
      d="m0 0h5l-1 18-7 76-11 116-4 39-4 27-6 29-8 26-6 17-13 30-12 23-12 19-12 17-10 13-9 11-12 13-21 21-11 9-16 13-17 12-16 10-19 11h-4v-262l1-20 4-29 6-25 8-26 10-23 8-16 8-14 10-15 9-12 11-13 9-10 17-17 11-9 14-11 21-14 16-9 23-11 19-7 15-5z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(990,1543)"
      d="m0 0 6 1 17 9 8 3 8-1 19-9 5-3h4l1 80-1 1h-66l-1-2z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1140,852)"
      d="m0 0h78l2 1 1 6 2 41v7l-83 1-1-2v-53z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(833,852)"
      d="m0 0h73l2 4v51l-7 1h-64l-12-1 1-48 1-6z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1038,770)"
      d="m0 0h71l3 1 1 19v35l-1 1h-74l-1-1-1-53z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(936,770)"
      d="m0 0h69l5 1 1 53-1 2h-74l-1-1-1-27v-26z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1038,688)"
      d="m0 0h72l2 1 1 16v38l-2 1h-73l-1-1v-54z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(936,688)"
      d="m0 0h68l6 2v53l-1 1h-73l-1-1-1-36v-17z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1038,606)"
      d="m0 0h33l41 1 1 12v42l-1 1h-74l-1-1v-54z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1038,934)"
      d="m0 0h73l1 1 1 8v45l-2 2-73-1-1-1v-53z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1038,852)"
      d="m0 0h73l1 1 1 14v39l-1 1-74 1-1-1v-54z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1038,1016)"
      d="m0 0h73l2 1-1 8-7 8-8 8-7 8-13 16-16 24-8 13-10 18-3 8h-3v-111z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1141,770)"
      d="m0 0 71 1 1 1 6 50v3l-2 1-77-1-1-1v-53z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(867,770)"
      d="m0 0h38l3 2v53l-2 1-76-1-1-3 5-49 1-2z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1037,525)"
      d="m0 0h75l1 28v26l-2 1h-73l-1-1z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(935,607)"
      d="m0 0h74l1 1 1 53-1 1h-74l-1-1-1-52z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(935,852)"
      d="m0 0h73l2 1v54l-74 1-1-1-1-34v-20z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(936,934)"
      d="m0 0h72l2 1 1 52-1 2h-75l-1-52z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(935,525)"
      d="m0 0h75v54l-1 1h-73l-1-1-1-47z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(939,1016)"
      d="m0 0h70l1 1 1 112-3-1-11-22-14-23-10-14-10-13-12-14-12-13-4-5v-7z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1006,424)"
      d="m0 0 4 1 1 72-1 1h-74l-1-1v-17l3-6 9-11 11-11 8-7 13-9 16-8z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1038,424)"
      d="m0 0 9 2 16 7 14 9 10 8 10 9 7 7 8 11 1 11v9l-1 1h-74l-1-1v-72z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1140,934)"
      d="m0 0h81l2 1v20l-12 6-16 7-21 11-13 8-17 12-4 1-1-2v-63z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1139,689)"
      d="m0 0h60l9 46 1 8-2 1h-67l-1-2z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(826,934)"
      d="m0 0h80l2 2v64l-5-1-8-6-14-9-21-12-22-11-12-5-1-1v-20z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(849,689)"
      d="m0 0h58l1 3v51l-2 1-67-1 1-9 8-43z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1173,606)"
      d="m0 0 4 1 7 23 8 28-1 4h-50l-2-5v-49l1-1z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(871,607)"
      d="m0 0h36l1 1v53l-1 1h-44l-7-1 2-10 12-42z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1140,524)"
      d="m0 0 3 1 10 21 12 28 1 6h-25l-1-1z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(905,524)"
      d="m0 0h2l1 31v24l-2 1-25-1 2-6 11-25 8-18z"
      fill="#FEFEFE"
    />
  </svg>
);
export default CRN;
